// extracted by mini-css-extract-plugin
module.exports = {"MenuGroup--max-height":"bgj_a"};